import { useEffect, useRef } from 'react';
import { useRouter } from 'next/router';
import Header from './Header';
import SiteFooter from './SiteFooter';
import MaintenancePreviewBanner from './MaintenancePreviewBanner';
import TitleBar from './TitleBar';
import GoToTop from './GoToTop';
// import PromoNotification from './PromoNotification';
import CustomScrollbar from './CustomScrollbar';
import { ScrollContainerProvider } from '../context/ScrollContainerContext';

export default function Layout({ children }) {
  const pageScrollRef = useRef(null);
  const router = useRouter();
  const titleBarSectionSpacing =
    router.pathname === '/'
      ? ''
      : '[&>section:first-of-type]:!pt-40 [&>div>section:first-of-type]:!pt-40';

  // Reset the custom-scrollbar scroll position to the top on full page
  // navigation (e.g. /products -> /spare-parts). We deliberately depend on
  // `pathname` (not `asPath`) so that in-page query updates — such as the
  // URL-synced filter changes from `useUrlSyncedFilters` — do not jump the
  // page back to the top while the user is interacting with chips or the
  // search input.
  useEffect(() => {
    const container = pageScrollRef.current;
    if (!container) return;

    container.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [router.pathname]);

  return (
    <div className="h-dvh overflow-hidden bg-[var(--dash-blacker)] text-[var(--dash-text)] transition-colors">
      <ScrollContainerProvider value={pageScrollRef}>
        <CustomScrollbar
          ref={pageScrollRef}
          className="h-full"
          scrollerClassName="h-full"
          contentClassName="flex min-h-full flex-col"
        >
          <Header />
          <TitleBar />
          <MaintenancePreviewBanner />
          <main className={`w-full flex-1 ${titleBarSectionSpacing}`}>{children}</main>
          <SiteFooter />
          {/* <PromoNotification /> */}
          <GoToTop scrollContainerRef={pageScrollRef} />
        </CustomScrollbar>
      </ScrollContainerProvider>
    </div>
  );
}
